import React from "react";

const Checkbox = ({id, type, name, handleClick, isChecked}) => {
    return (
        <div className="custom-control custom-checkbox">
            <input className="custom-control-input"
                   type={type}
                   id={id}
                   name={name}
                   onChange={handleClick}
                   checked={isChecked}/>
            <label className="custom-control-label"
                   htmlFor={id}>{name}</label>
        </div>
    );
};

export default Checkbox;
